import { PROFILE_PAGES } from "@/react/helpers/memberHelper";
import { PROFILE_INFO_QUERY_KEY } from "@/react/hooks/profile/useProfileInfo";

export const generateInvalidateMemberQueryKey = (memberPublicId: string) => [
  PROFILE_INFO_QUERY_KEY,
  memberPublicId,
  {
    page_name: PROFILE_PAGES.PROFILE_VIEW,
  },
];
